import type { Release } from '../releases';

export default {
  id: '2026-11-01-site-offline-reports',
  at: '2026-11-02T03:45:00Z',
  title:
    'Площадка без связи: отчёты уходят и без открытого черновика, замечание и приёмка сохраняются в режиме полёта',
  modules: ['site'],
  items: [
    'Отчёты смены, сохранённые на телефоне, уходят на портал сами, как только появилась связь, — даже если черновик не открыт: достаточно открыть «Мой день». Там же видно, сколько отчётов ждёт связи.',
    'Замечание с фото и приёмка поставки теперь надёжно сохраняются на телефоне в режиме полёта: раньше без сети кнопка могла бесконечно «думать».',
  ],
  why: 'Прораб на объекте часто без связи: отчёт уходил только из открытого черновика, а замечание и приёмка без сети могли не сохраниться.',
  link: '/site/day',
} satisfies Release;
